import { Gender } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const genderMessages = defineMessages({
  female: {
    defaultMessage: 'Female',
    description: 'gender title',
  },
  male: {
    defaultMessage: 'Male',
    description: 'gender title',
  },
})

export function translateGender(intl: IntlShape, gender: Gender): string {
  switch (gender) {
    case Gender.FEMALE:
      return intl.formatMessage(genderMessages.female)
    case Gender.MALE:
      return intl.formatMessage(genderMessages.male)
  }
}
